import type { LumpsumRebalanceCategory, LumpsumRebalanceSellRecommendation } from '../../../../api/rebalance.types'
import {
  PlanCategoryBucketKey,
  PLAN_CATEGORY_BUCKET_TITLES,
  PlansPlanMode,
  type PlansActionFilter
} from '../../../../api/types'
import { usePlanCategoryBucket } from '../../../usePlanCategoryBucketExpansion'
import { BucketAccordion } from '../../../lumpsum-ui-components/BucketAccordion'
import { RebalanceSellFundCard } from '../cards/RebalanceSellFundCard'
import { getCategoryBucketItems } from '../../../../../utils/categoryBucketsUtils'
import { EventNames } from '../../../../../../../../types/misc.types'
import { trackEvent } from '../../../../../../../../utils/appBridge'
import { PlansLumpsumListEventIds, PlansScreen } from '../../../../../analytics/plansEvents'

type RebalanceSellBucketAccordionProps = {
  category: LumpsumRebalanceCategory
  categoryId: string
  actionFilter: PlansActionFilter
  isBorderTop?: boolean
}

export function RebalanceSellBucketAccordion({
  category,
  categoryId,
  actionFilter,
  isBorderTop = false
}: RebalanceSellBucketAccordionProps) {
  const sellRecommendations = getCategoryBucketItems<LumpsumRebalanceSellRecommendation>(category?.sellRecommendations)
  const { bucketCompositeKey, isExpanded, toggle } = usePlanCategoryBucket({
    planMode: PlansPlanMode.REBALANCE,
    actionFilter,
    categoryId,
    bucketKey: PlanCategoryBucketKey.sellRecommendations
  })

  return (
    <BucketAccordion
      bucketCompositeKey={bucketCompositeKey}
      title={PLAN_CATEGORY_BUCKET_TITLES[PlanCategoryBucketKey.sellRecommendations]}
      count={sellRecommendations.length}
      isExpanded={isExpanded}
      onToggle={() => {
        trackEvent({
          eventName: EventNames.UserClicked,
          payload: {
            ScreenName: PlansScreen.LumpsumRebalance,
            eventId: PlansLumpsumListEventIds.BucketAccordion,
            buttonLabel: PLAN_CATEGORY_BUCKET_TITLES[PlanCategoryBucketKey.sellRecommendations]
          }
        })
        toggle()
      }}
      isBorderTop={isBorderTop}
    >
      {sellRecommendations.map((recommendation, recommendationIndex) => (
        <RebalanceSellFundCard
          key={`${recommendation?.isin ?? 'fund'}-${recommendationIndex}`}
          recommendation={recommendation}
          showBottomDivider={recommendationIndex < sellRecommendations.length - 1}
        />
      ))}
    </BucketAccordion>
  )
}
